import React, { useState } from "react"
import CounsellingPatients from "./counsellingPatients"
import CollaboratingColleagues from "./collaboratingColleagues"
import { ChildTabsComponent } from "../components"
import { useTranslation } from "react-i18next"
import TransMsg from "./transMessage"

const Management = () => {
  const { t } = useTranslation()
  const [managementTabValue, setManagementTabValue] = useState(0);

  const managementTabs = [
    {
      tabLabel: t(TransMsg.COUNSELLING_PATIENTS_LABEL),
      children: <CounsellingPatients />
    },
    {
      tabLabel: t(TransMsg.COLLABORATING_COLLEAGUES_LABEL),
      children: <CollaboratingColleagues />
    }
  ]

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setManagementTabValue(newValue);
  };

  return (
    <ChildTabsComponent
      tabsList={managementTabs}
      value={managementTabValue}
      handleChange={handleChange}
    />
  )
}

export default Management